import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Edu › Quản lý đào tạo (Manage.tsx). Mã nghiệp vụ và dữ liệu mẫu không dịch.
addMessages('vi', {
  'mg.onb': 'Nhập môn người mới',
  'mg.onbTitle': 'Gắn với checklist nhận việc: tài khoản, quyền theo ghế, khoá bắt buộc tuần đầu, người kèm cặp',
  'mg.onTime': 'Đúng hạn theo phòng',
  'mg.quarter': 'Quý {q}',
  'mg.gaugeAria': 'Toàn công ty hoàn thành đúng hạn {v}%, mục tiêu KPI {g}%',
  'mg.company': 'toàn công ty',
  'mg.pts': '−{n} điểm %',
  'mg.byPerson': 'Theo người',
  'mg.coursesDone': 'Khoá xong',
  'mg.late': 'Trễ',
  'mg.byExam': 'Theo bài kiểm tra',
  'mg.passTitle': 'Tỷ lệ đạt (≥ 80%) · vạch = mục tiêu 90%',
  'mg.pass': 'Tỷ lệ đạt ⓘ',
  'mg.avg': 'Điểm TB',
  'mg.triesTitle': 'Số lần làm bài',
  'mg.tries': 'Lần',
  'mg.score': 'Điểm',
  'mg.locked': 'Quản lý đào tạo chỉ HR và trưởng bộ phận mở được',
  'mg.home': 'Về Trang chủ',
  'mg.title': 'Quản lý đào tạo',
  'mg.tAssign': 'Giao khoá',
  'mg.tDone': 'Hoàn thành',
  'mg.tScore': 'Kết quả thi',
  'mg.assignToast': 'Giao khoá học: chọn khoá và ghế / phòng (chưa ghi ở bản này)',
  'mg.assignBtn': '+ Giao khoá học',
});
addMessages('en', {
  'mg.onb': 'New-hire onboarding',
  'mg.onbTitle': 'Tied to the onboarding checklist: account, seat permissions, first-week mandatory courses, buddy',
  'mg.onTime': 'On time by department',
  'mg.quarter': 'Q{q}',
  'mg.gaugeAria': 'Company-wide on-time completion {v}%, KPI target {g}%',
  'mg.company': 'company-wide',
  'mg.pts': '−{n} pts %',
  'mg.byPerson': 'By person',
  'mg.coursesDone': 'Courses done',
  'mg.late': 'Late',
  'mg.byExam': 'By exam',
  'mg.passTitle': 'Pass rate (≥ 80%) · line = 90% target',
  'mg.pass': 'Pass rate ⓘ',
  'mg.avg': 'Avg. score',
  'mg.triesTitle': 'Number of attempts',
  'mg.tries': 'Tries',
  'mg.score': 'Score',
  'mg.locked': 'Training management is open to HR and department heads only',
  'mg.home': 'Back to Home',
  'mg.title': 'Training management',
  'mg.tAssign': 'Assign',
  'mg.tDone': 'Completed',
  'mg.tScore': 'Exam results',
  'mg.assignToast': 'Assign a course: pick a course and seat / department (not writable in this version)',
  'mg.assignBtn': '+ Assign course',
});
